export const en = {
  lang: 'en-US',
  accessibility: {
    info: 'info',
    success: 'success',
    warning: 'warning',
    error: 'error',
    close: 'close',
    page: 'page',
    prev: 'prev',
    next: 'next',
    back: 'back',
  },
  ConfirmModal: {
    title: 'Notification',
    confirmText: 'OK',
    cancelText: 'Cancel',
  },
  AlertModal: {
    title: 'Notification',
    confirmText: 'OK',
  },
  NoticeModal: {
    closeText: 'Close',
    checkReplayText: 'Do not open this window for one day',
  },
  Dropdown: {
    placeholder: 'Select',
    filterPlaceholder: 'Search Filter',
  },
  DropdownFilter: {
    reset: 'Reset',
    confirm: 'Confirm',
    all: 'All',
  },
  DatePicker: {
    placeholder: 'Select date',
    footer: {
      now: 'Now',
      today: 'Today',
      ok: 'OK',
      clear: 'Clear',
    },
  },
  DatePickerRange: {
    placeholder: ['Start date', 'End date'],
    dataPreset: {
      'today': 'Today',
      '1-week': '1 Week',
      '1-month': '1 Month',
      '3-month': '3 Month',
      '6-month': '6 Month',
      '1-year': '1 Year',
      'all': 'All',
    },
  },
  TimePicker: {
    placeholder: 'Select time',
    footer: {
      ok: 'OK',
      clear: 'Clear',
    },
    unit: {
      hour: 'h',
      minute: 'm',
    },
  },
  TimeRangePicker: {
    placeholder: ['Start time', 'End time'],
  },
  FileUpload: {
    label: 'Upload File',
  },
  ImageUpload: {
    label: 'Upload Image',
    fail: 'Image failed to load',
  },
  Table: {
    noDataText: 'No data',
  },
  ColumnViewController: {
    noFixedItemsText: 'No fixed items',
    fixedSectionTitle: 'Fixed Section',
    listSectionTitle: 'List Section',
    max: 'max',
    items: ' items',
  },
  CategorySelector: {
    levelCategory: '-Level Category',
    selectParentCategoryLine1: 'Please select',
    selectParentCategoryLine2: 'a parent category.',
  },
};
